import { applyBarChartTheme } from '@/libs/barChartTheme'

let echarts = require('echarts/lib/echarts')

/**
 * 统计页 ECharts 公共逻辑：深拷贝 option 再套主题，切换数据时销毁实例并防竞态
 */
export default {
    data() {
        return {
            chartInstance: null,
            chartDataRequestId: 0,
        }
    },
    watch: {
        list_model(val) {
            if (val !== 2) {
                this.disposeChart()
            }
        }
    },
    beforeDestroy() {
        this.disposeChart()
    },
    methods: {
        getChartRequestKey() {
            return this.pid
        },
        disposeChart() {
            if (this.chartInstance) {
                this.chartInstance.dispose()
                this.chartInstance = null
            }
            const chartEl = this.$refs.statisticChart
            if (chartEl) {
                const existing = echarts.getInstanceByDom(chartEl)
                if (existing) {
                    existing.dispose()
                }
            }
        },
        cloneChartOption(option) {
            return JSON.parse(JSON.stringify(option))
        },
        renderChart(option) {
            this.$nextTick(() => {
                const chartEl = this.$refs.statisticChart
                if (!chartEl) return
                this.disposeChart()
                this.chartInstance = echarts.init(chartEl)
                const chartOption = applyBarChartTheme(this.cloneChartOption(option))
                this.chartInstance.setOption(chartOption, true)
                this.chartInstance.resize()
            })
        },
        beginChartRequest() {
            const requestId = ++this.chartDataRequestId
            const requestKey = this.getChartRequestKey()
            return { requestId, requestKey }
        },
        isStaleChartRequest(requestId, requestKey) {
            return requestId !== this.chartDataRequestId || requestKey !== this.getChartRequestKey()
        },
        invalidateChartRequest() {
            this.chartDataRequestId += 1
        },
        onChartTargetSwitch() {
            this.invalidateChartRequest()
            this.disposeChart()
            this.resetChartData()
            this.echarts_show = 0
        },
    }
}
